import { type ReactNode } from "react";
import { Modal } from "../ui/Modal";
import { ConfirmDialog as UIConfirmDialog } from "../ui/ConfirmDialog";

export interface AdminConfirmDialogProps {
  open?: boolean;
  isOpen?: boolean;
  title: string;
  message?: ReactNode;
  description?: ReactNode;
  confirmLabel?: string;
  confirmText?: string;
  danger?: boolean;
  variant?: "primary" | "destructive" | string;
  loading?: boolean;
  busy?: boolean;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

export function ConfirmDialog({
  open,
  title,
  message,
  description,
  confirmLabel = "Confirm",
  confirmText,
  danger,
  variant = "primary",
  loading,
  busy,
  onConfirm,
  onClose,
  isOpen,
}: AdminConfirmDialogProps) {
  const isDestructive = variant === "destructive" || Boolean(danger);
  const resolvedMessage = message ?? description ?? "";
  const resolvedConfirmText = confirmText ?? confirmLabel;
  const resolvedLoading = Boolean(loading ?? busy);

  return (
    <UIConfirmDialog
      isOpen={open ?? isOpen ?? false}
      title={title}
      message={resolvedMessage}
      confirmText={resolvedConfirmText}
      variant={isDestructive ? "destructive" : "primary"}
      loading={resolvedLoading}
      onConfirm={onConfirm}
      onCancel={onClose}
    />
  );
}

export function ModalShell({
  open,
  title,
  subtitle,
  onClose,
  children,
  wide,
}: {
  open: boolean;
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: ReactNode;
  wide?: boolean;
}) {
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={title}
      description={subtitle}
      size={wide ? "lg" : "md"}
    >
      {children}
    </Modal>
  );
}
